var map = {
	"./aparthotelclub/ic_tag_music.png": 96057,
	"./beachful/ic_tag_music.png": 6560,
	"./castlepedia/ic_tag_music.png": 46274,
	"./cocktayl/ic_tag_music.png": 12886,
	"./ic_tag_music.png": 35707,
	"./luxresortclub/ic_tag_music.png": 34632,
	"./parkful/ic_tag_music.png": 46388,
	"./prefabworld/ic_tag_music.png": 3233,
	"./rooftopclub/ic_tag_music.png": 89840,
	"./spaclub/ic_tag_music.png": 59919,
	"./worldcasino/ic_tag_music.png": 18027,
	"./zoopedia/ic_tag_music.png": 95021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21106;